import { render, staticRenderFns } from "./ComboboxConsultores.vue?vue&type=template&id=3131ae53"
import script from "./ComboboxConsultores.vue?vue&type=script&lang=js"
export * from "./ComboboxConsultores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports